import React, { memo, useMemo, useState, useContext, useCallback } from 'react';
import map from 'lodash/map';
import { TableCell, Table, TableHead, TableRow, TableBody, Card, useMediaQuery, InputLabel, TextField } from '@material-ui/core';
import isPlainObject from 'lodash/isPlainObject';
import get from 'lodash/get';
import omit from 'lodash/omit';
import { useOnMount } from '@seasonedsoftware/utils/dist/hooks';
import { Rating as Rating$1 } from '@material-ui/lab';
import Snackbar from '@material-ui/core/Snackbar';
import { Countdown } from '@seasonedsoftware/utils/dist/ui';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from '@material-ui/icons/Close';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';
import IconButton from '@material-ui/core/IconButton';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import WarningIcon from '@material-ui/icons/Warning';
import { withStyles } from '@material-ui/core/styles';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var Cell = function Cell(_ref) {
  var content = _ref.content,
      align = _ref.align;
  var isReact = get(content, '$$typeof');
  var isObj = !isReact && isPlainObject(content);
  var text = isObj ? get(content, 'content') : content;
  return React.createElement(TableCell, _extends({
    align: align
  }, isObj ? omit(content, 'content') : {}), text);
};

var OurTable = function OurTable(_ref) {
  var data = _ref.data,
      _ref$scrollable = _ref.scrollable,
      scrollable = _ref$scrollable === void 0 ? true : _ref$scrollable,
      _ref$tableProps = _ref.tableProps,
      tableProps = _ref$tableProps === void 0 ? {} : _ref$tableProps;

  var _data = _slicedToArray(data, 1),
      firstSet = _data[0];

  return React.createElement("div", {
    style: scrollable ? {
      overflowX: 'auto',
      width: '100%'
    } : {}
  }, React.createElement(Table, tableProps, React.createElement(TableHead, null, React.createElement(TableRow, null, Object.keys(firstSet).map(function (title, index) {
    return React.createElement(TableCell, {
      key: "tableheader-".concat(index)
    }, title);
  }))), React.createElement(TableBody, null, data.map(function (row, index) {
    return React.createElement(TableRow, {
      key: "tablerow-".concat(index)
    }, map(row, function (cellValue, cellKey) {
      return React.createElement(Cell, {
        key: "tablecell-".concat(index, "-").concat(cellKey),
        content: cellValue
      });
    }));
  }))));
};

var OurList = function OurList(_ref) {
  var _ref$data = _ref.data,
      data = _ref$data === void 0 ? [] : _ref$data,
      cardProps = _ref.cardProps,
      scrollable = _ref.scrollable,
      _ref$tableProps = _ref.tableProps,
      tableProps = _ref$tableProps === void 0 ? {} : _ref$tableProps;
  return React.createElement("div", null, data.map(function (row, index) {
    return React.createElement(Card, _extends({}, cardProps, {
      key: "card-".concat(index)
    }), React.createElement("div", {
      style: scrollable ? {
        overflowX: 'auto',
        width: '100%'
      } : {}
    }, React.createElement(Table, tableProps, React.createElement(TableBody, null, map(row, function (cellValue, cellKey) {
      return cellValue ? React.createElement(TableRow, {
        key: "tablecell-".concat(index, "-").concat(cellKey)
      }, React.createElement(TableCell, null, cellKey), React.createElement(Cell, {
        align: "right",
        content: cellValue
      })) : null;
    })))));
  }));
};

var ResponsiveTable = function ResponsiveTable(_ref) {
  var data = _ref.data,
      _ref$scrollable = _ref.scrollable,
      scrollable = _ref$scrollable === void 0 ? false : _ref$scrollable,
      _ref$tableProps = _ref.tableProps,
      tableProps = _ref$tableProps === void 0 ? {} : _ref$tableProps,
      _ref$mobileTableProps = _ref.mobileTableProps,
      mobileTableProps = _ref$mobileTableProps === void 0 ? {} : _ref$mobileTableProps,
      _ref$cardProps = _ref.cardProps,
      cardProps = _ref$cardProps === void 0 ? {} : _ref$cardProps,
      _ref$mediaQuery = _ref.mediaQuery,
      mediaQuery = _ref$mediaQuery === void 0 ? '(min-width:600px)' : _ref$mediaQuery;
  if (data.length < 1) return null;
  var matches = useMediaQuery(mediaQuery);
  return matches ? React.createElement(OurTable, {
    data: data,
    scrollable: scrollable,
    tableProps: tableProps
  }) : React.createElement(OurList, {
    data: data,
    scrollable: scrollable,
    cardProps: cardProps,
    tableProps: mobileTableProps
  });
};

function initSubjects(subjects) {
  return subjects.reduce(function (sum, curr) {
    sum[curr.name] = curr.value;
    return sum;
  }, {});
}
function formatSubject(subject) {
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
  var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return typeof subject === 'string' ? {
    name: subject,
    max: max,
    title: subject,
    value: value
  } : _objectSpread2({}, subject, {
    title: subject.title || subject.name,
    max: subject.max || max,
    value: subject.value || value
  });
}

var Rating = function Rating(_ref) {
  var onChange = _ref.onChange,
      subject = _ref.subject,
      showLabel = _ref.showLabel,
      value = _ref.value,
      allowHalf = _ref.allowHalf,
      readOnly = _ref.readOnly,
      icon = _ref.icon,
      emptyIcon = _ref.emptyIcon;

  var roundPrecision = function roundPrecision() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return Math.round(value * 2) / 2;
  };

  var displayValue = roundPrecision(value);

  var onChoice = function onChoice(_event, value) {
    onChange(subject.name || 'rating', value);
  };

  return React.createElement("div", null, showLabel && React.createElement(InputLabel, null, subject.title), React.createElement(Rating$1, {
    icon: icon,
    emptyIcon: emptyIcon,
    name: subject.title,
    precision: allowHalf ? 0.5 : 1,
    onChange: onChoice,
    value: displayValue,
    max: subject.max,
    readOnly: readOnly
  }));
};

var EvaluatorComponent = function EvaluatorComponent(_ref) {
  var onChange = _ref.onChange,
      subjects = _ref.subjects,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? 'rating' : _ref$name,
      commentLabel = _ref.commentLabel,
      enableComment = _ref.enableComment,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? 0 : _ref$value,
      props = _objectWithoutProperties(_ref, ["onChange", "subjects", "name", "commentLabel", "enableComment", "value"]);

  var formatter = function formatter(subject) {
    return formatSubject(subject, props.max, value);
  };

  var defaultSubjects = subjects || [name];
  var formatedSubjects = useMemo(function () {
    return defaultSubjects.map(formatter);
  }, []);
  var allSubjects = initSubjects(formatedSubjects);

  var _useState = useState(allSubjects),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      comment = _useState4[0],
      setComment = _useState4[1];

  useOnMount(function () {
    return onChange && onChange(state);
  });

  var onChangeRating = function onChangeRating(name, value) {
    var newState = _objectSpread2({}, state, _defineProperty({}, name, value));

    setState(newState);
    return onChange ? onChange(enableComment ? _objectSpread2({}, newState, {
      comment: comment
    }) : newState) : undefined;
  };

  var updateComment = function updateComment(event) {
    if (!onChange) return undefined;
    var comment = event.target.value;
    setComment(comment);
    return onChange(_objectSpread2({}, state, {
      comment: comment
    }));
  };

  return React.createElement(React.Fragment, null, map(formatedSubjects, function (subject, index) {
    return React.createElement(Rating, _extends({
      key: index,
      onChange: onChangeRating,
      subject: subject,
      value: state[subject.name],
      showLabel: formatedSubjects.length > 1
    }, props));
  }), enableComment && React.createElement(TextField, {
    value: comment,
    onChange: updateComment,
    label: commentLabel,
    multiline: true,
    fullWidth: true
  }));
};

EvaluatorComponent.defaultProps = {
  commentLabel: 'Leave your comment',
  enableComment: false,
  readOnly: false
};
var Evaluator = memo(EvaluatorComponent);

var variantIcon = {
  error: ErrorIcon,
  info: InfoIcon,
  success: CheckCircleIcon,
  warning: WarningIcon
};

var styles = function styles(theme) {
  return {
    error: {
      backgroundColor: theme.palette.error.dark
    },
    icon: {
      fontSize: 20
    },
    iconVariant: {
      marginRight: theme.spacing(1),
      opacity: 0.9
    },
    info: {
      backgroundColor: theme.palette.primary.dark
    },
    message: {
      alignItems: 'center',
      display: 'flex'
    },
    success: {
      backgroundColor: green[600]
    },
    warning: {
      backgroundColor: amber[700]
    }
  };
};

var Message = function Message(_ref) {
  var _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 0 : _ref$timeout,
      classes = _ref.classes,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      text = _ref.text,
      close = _ref.close,
      noIcon = _ref.noIcon,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'info' : _ref$type;
  var Icon = variantIcon[type];

  var onFinish = function onFinish() {
    return timeout > 0 ? close() : null;
  };

  return React.createElement(SnackbarContent, {
    className: classes[type],
    style: style,
    message: React.createElement(React.Fragment, null, React.createElement(Countdown, {
      time: timeout,
      onFinish: onFinish,
      active: true
    }), React.createElement("span", {
      id: "client-snackbar",
      className: classes.message
    }, noIcon || React.createElement(Icon, {
      className: "".concat(classes.icon, " ").concat(classes.iconVariant)
    }), text)),
    action: [React.createElement(IconButton, {
      key: "close",
      "aria-label": "Close",
      color: "inherit",
      onClick: close
    }, React.createElement(CloseIcon, {
      className: classes.icon
    }))]
  });
};

var Message$1 = withStyles(styles)(Message);

var MessagesController = (function (_ref) {
  var message = _ref.message,
      close = _ref.close,
      willClose = _ref.willClose,
      noIcon = _ref.noIcon,
      style = _ref.style,
      open = _ref.open,
      position = _ref.position;
  return message && message.text ? React.createElement(Snackbar, {
    anchorOrigin: position || {
      horizontal: 'right',
      vertical: 'bottom'
    },
    open: open,
    onClose: close
  }, React.createElement(Message$1, _extends({
    noIcon: noIcon,
    close: willClose,
    style: style
  }, message))) : null;
});

var defaultDispatcher = function defaultDispatcher(_) {};

var Context = React.createContext(defaultDispatcher);
var SnackbarProvider = function SnackbarProvider(_ref) {
  var children = _ref.children,
      noIcon = _ref.noIcon,
      position = _ref.position,
      style = _ref.style;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      message = _useState2[0],
      setMessage = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      open = _useState4[0],
      setOpen = _useState4[1];

  var dispatch = function dispatch(text) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'info';
    var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 4;
    var messageObj = {
      text: text,
      timeout: timeout,
      type: type
    };
    setMessage(messageObj);
    setOpen(true);
  };

  var close = function close() {
    return setMessage(null);
  };

  var willClose = function willClose() {
    return setOpen(false);
  };

  return React.createElement(Context.Provider, {
    value: dispatch
  }, React.createElement(MessagesController, {
    noIcon: noIcon,
    position: position,
    message: message,
    open: open,
    style: style,
    willClose: willClose,
    close: close
  }), children);
};

var useSnackbar = function useSnackbar() {
  var dispatch = useContext(Context);
  var makeDispatcher = useCallback(function (type) {
    return function (text, timeout) {
      dispatch(text, type, timeout);
    };
  }, []);
  var actions = useMemo(function () {
    return {
      error: makeDispatcher('error'),
      flash: dispatch,
      info: makeDispatcher('info'),
      success: makeDispatcher('success'),
      warning: makeDispatcher('warning')
    };
  }, []);
  return actions;
};

export { Evaluator, ResponsiveTable, SnackbarProvider, useSnackbar };
